/* eslint-disable react/prop-types */
import React from 'react';
import Button from '@atlaskit/button';
import Spinner from '@atlaskit/spinner';
import User, { isValidAiApiKey } from '../../../../tools/user';

const ChatControls = ({
  tokensInfo, isFetching, handleData, reportData, confirmDeleteChannel,
}) => {
  const user = User.getUserInfo();
  const hasApiKey = isValidAiApiKey(user);

  if (!hasApiKey) return null;

  return (
    reportData ? (
      <div style={{
        display: 'flex',
        gap: 4,
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginRight: 6,
      }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {tokensInfo && (
          <>
            <div>
              {'Tokens used: '}
              {tokensInfo.total_tokens}
            </div>
          </>
          )}
        </div>
        <Button appearance="primary" onClick={handleData}>
          {isFetching ? (
            <>
                Updating...
              <Spinner invertColor size="small" />
            </>
          ) : 'Reload'}
        </Button>
        <Button appearance="danger" onClick={confirmDeleteChannel}>
              x
        </Button>
      </div>
    ) : (
      <div style={{ marginRight: 3 }}>
        <Button appearance="primary" onClick={handleData}>
          {isFetching ? (
            <>
              Loading...
              <Spinner invertColor size="small" />
            </>
          ) : 'Ask AI'}
        </Button>
      </div>
    )
  );
};

export default ChatControls;
